<template>
  <el-dialog
    v-if="isShow"
    title="Attach File to Attachment"
    :visible.sync="isShow"
    top="5vh"
    style="text-align: center;"
    :close-on-click-modal="false"
  >
    <el-autocomplete
      v-model="selectedFile.name"
      :fetch-suggestions="querySearchAsync"
      placeholder="Enter file name"
      :trigger-on-focus="false"
      class="w-100"
      placement="top"
      :debounce="500"
      clearable
      value-key="name"
      @select="handleSelect"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :disabled="!selectedFile.id"
        :loading="isSaving"
        @click.native="save"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    consignmentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isShow: false,
      isSaving: false,
      selectedFile: {}
    }
  },
  methods: {
    save () {
      this.isSaving = true
      this.$file.setGenericAttachment(this.selectedFile.id, this.consignmentId, 'consignment')
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.isShow = false
          this.$emit('saved')
        })
    },
    querySearchAsync (queryString, cb) {
      this.$sdk.file.list(builder => {
        builder.page = 1
        builder.limit = 20
        builder.filters = { resource: 'name', ids: [queryString] }
        builder.order = 'name:asc'
      }).then(res => {
        cb(res)
      })
    },
    handleSelect (item) {
      this.selectedFile = item
    }
  }
}
</script>
